import remarkGfm from 'remark-gfm';
import ReactMarkdown from 'react-markdown';

import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

import { RouterLink } from 'src/routes/components';

/**
 * The assistant's answers as markdown (JT1-1779). Its links to records are relative
 * (`/dashboard/candidates/...`) and open in the app; anything else opens in a new tab. No raw HTML:
 * the text comes from a model.
 */
export default function AssistantMarkdown({ text }: { text: string }) {
  return (
    <Typography
      variant="body2"
      component="div"
      sx={{
        '& p': { m: 0, mb: 0.75 },
        '& p:last-child': { mb: 0 },
        '& ul, & ol': { pl: 2, m: 0, mb: 0.75 },
        '& li': { mb: 0.25 },
        '& table': { borderCollapse: 'collapse', width: '100%', fontSize: 12, my: 0.75 },
        '& th, & td': { border: '1px solid', borderColor: 'divider', p: 0.5, textAlign: 'left' },
        '& h1, & h2, & h3': { mt: 1, mb: 0.5, fontSize: 14 },
        '& blockquote': { borderLeft: '3px solid', pl: 1, ml: 0, opacity: 0.8 },
        '& code': { fontSize: 12 },
      }}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ href, children }) =>
            href?.startsWith('/') ? (
              <Link component={RouterLink} href={href}>{children}</Link>
            ) : (
              <Link href={href} target="_blank" rel="noopener noreferrer">{children}</Link>
            ),
        }}
      >
        {text}
      </ReactMarkdown>
    </Typography>
  );
}
